import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StaffLayer from "../components/StaffLayer";

const StaffPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Staff' />

        {/* BlogLayer */}
        <StaffLayer />
      </MasterLayout>
    </>
  );
};

export default StaffPage;
